<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/38NcqG/tc-custom/9781473840904.jpg?1703823967121" alt="This image is the cover for the book Carlisle in the Great War, Your Towns & Cities in the Great War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carlisle in the Great War, Your Towns & Cities in the Great War
      </h1>
      <p class="bookDescription body article font2">
        <p>How the experience of war impacted on the town, from the initial enthusiasm for sorting out the German kaiser in time for Christmas 1914, to the gradual realization of the enormity of human sacrifice the families of Carlisle were committed to as the war stretched out over the next four years. A record of the growing disillusion of the people, their tragedies and hardships and a determination to see it through. Already an important railway junction, with local industrial and commercial interests reflecting its historical position on the border with Scotland, Carlisle became a key settlement in the Great War. The Carlisle story includes the arrival of Belgian Refugees; the care of wounded men passing through the city on hospital trains; recruiting the Lonsdale Battalion; dealing with the aftermath of the Gretna rail disaster; caring for the wounded brought to the local hospitals after major battles; the effect of the Gretna Munitions factory on the city and state ownership of public houses and breweries. Beneath these new activities normal life continued with children going to school, local government dealing with a growing population and daily work and commerce</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David M Carter
      </h2>
      
      <p class="authorDescription body article">David Carter is a retired headteacher and school inspector who taught history. He has written scripts and produced programmes for local radio. His research has covered many aspects of local history and was used in resource packs for schools. He now focuses on military, local and family history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c5f38ce